import { render, staticRenderFns } from "./timezone-clock.vue?vue&type=template&id=31fd5c79&scoped=true"
import script from "./timezone-clock.vue?vue&type=script&lang=js"
export * from "./timezone-clock.vue?vue&type=script&lang=js"
import style0 from "./timezone-clock.vue?vue&type=style&index=0&id=31fd5c79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fd5c79",
  null
  
)

export default component.exports